// extracted by mini-css-extract-plugin
module.exports = {"makes":"makes-module--makes--16LOs"};